import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AutenticacaoService } from "../_services/autenticacao/autenticacao.service";
import { RolesInterface, Utilitarios } from "./utilitarios.common";

@Injectable({
  providedIn: 'root'
})

export class BaseClass {

  public isAdmin: boolean = Utilitarios.IsAdmin;

  public roleListarCliente: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarCliente: boolean = false || Utilitarios.IsAdmin;
  public roleEditarCliente: boolean = false || Utilitarios.IsAdmin;
  public roleDetalheCliente: boolean = false || Utilitarios.IsAdmin;
  public roleContatoCliente: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarCliente: boolean = false || Utilitarios.IsAdmin;

  public roleListarUsuario: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarUsuario: boolean = false || Utilitarios.IsAdmin;
  public roleEditarUsuario: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarUsuario: boolean = false || Utilitarios.IsAdmin;

  public roleListarRemetente: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarRemetente: boolean = false || Utilitarios.IsAdmin;
  public roleEditarRemetente: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarRemetente: boolean = false || Utilitarios.IsAdmin;

  public roleListarDestinatarios: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarDestinatario: boolean = false || Utilitarios.IsAdmin;
  public roleEditarDestinatario: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarDestinatario: boolean = false || Utilitarios.IsAdmin;

  public roleListarConfigEmail: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarConfigEmail: boolean = false || Utilitarios.IsAdmin;
  public roleEditarConfigEmail: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarConfigEmail: boolean = false || Utilitarios.IsAdmin;

  public roleListarPainel: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarPainel: boolean = false || Utilitarios.IsAdmin;
  public roleEditarPainel: boolean = false || Utilitarios.IsAdmin;
  public roleListarWidget: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarWidget: boolean = false || Utilitarios.IsAdmin;

  public roleListarDashboardConfiguracao: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarDashboardConfiguracao: boolean = false || Utilitarios.IsAdmin;
  public roleEditarDashboardConfiguracao: boolean = false || Utilitarios.IsAdmin;

  public roleListarHardwareGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarHardwareGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleEditarHardwareGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarHardwareGrupo: boolean = false || Utilitarios.IsAdmin;

  public roleListarMonitoracao: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarComputadores: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarMonitoracao: boolean = false || Utilitarios.IsAdmin;
  public roleInserirGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleEditarAlias: boolean = false || Utilitarios.IsAdmin;

  public roleListarVisualizacao: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarVisualizacao: boolean = false || Utilitarios.IsAdmin;
  public roleEditarVisualizacao: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarGrupoItem: boolean = false || Utilitarios.IsAdmin;

  public roleListarOcorrencia: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarOcorrencia: boolean = false || Utilitarios.IsAdmin;
  public roleEditarOcorrencia: boolean = false || Utilitarios.IsAdmin;

  public roleListarTipoOcorrencia: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarTipoOcorrencia: boolean = false || Utilitarios.IsAdmin;
  public roleEditarTipoOcorrencia: boolean = false || Utilitarios.IsAdmin;

  public roleListarEvento: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarEvento: boolean = false || Utilitarios.IsAdmin;
  public roleEditarEvento: boolean = false || Utilitarios.IsAdmin;

  public roleListarTipoEvento: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarTipoEvento: boolean = false || Utilitarios.IsAdmin;
  public roleEditarTipoEvento: boolean = false || Utilitarios.IsAdmin;

  public roleListarOrigem: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarOrigem: boolean = false || Utilitarios.IsAdmin;
  public roleEditarOrigem: boolean = false || Utilitarios.IsAdmin;

  public roleListarOrigemFilho: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarOrigemFilho: boolean = false || Utilitarios.IsAdmin;
  public roleEditarOrigemFilho: boolean = false || Utilitarios.IsAdmin;

  public roleListarGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleEditarGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarGrupoDestinatario: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarGrupoDestinatario: boolean = false || Utilitarios.IsAdmin;

  public roleListarAlarme: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarAlarme: boolean = false || Utilitarios.IsAdmin;
  public roleEditarAlarme: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarAlarme: boolean = false || Utilitarios.IsAdmin;

  public roleListarAlarmeAlias: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarAlarmeAlias: boolean = false || Utilitarios.IsAdmin;
  public roleEditarAlarmeAlias: boolean = false || Utilitarios.IsAdmin;

  public roleListarAgendamento: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarAgendamento: boolean = false || Utilitarios.IsAdmin;
  public roleEditarAgendamento: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarAgendamento: boolean = false || Utilitarios.IsAdmin;

  public roleListarAuditor: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarAuditor: boolean = false || Utilitarios.IsAdmin;
  public roleEditarAuditor: boolean = false || Utilitarios.IsAdmin;

  public roleListarRestricao: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarRestricao: boolean = false || Utilitarios.IsAdmin;
  public roleEditarRestricao: boolean = false || Utilitarios.IsAdmin;

  public roleListarModulo: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarModulo: boolean = false || Utilitarios.IsAdmin;
  public roleEditarModulo: boolean = false || Utilitarios.IsAdmin;

  public roleListarServico: boolean = false || Utilitarios.IsAdmin;

  public roleListarReportConexao: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarReportConexao: boolean = false || Utilitarios.IsAdmin;
  public roleEditarReportConexao: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarReportConexao: boolean = false || Utilitarios.IsAdmin;

  public roleListarReportGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarReportGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleEditarReportGrupo: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarReportGrupo: boolean = false || Utilitarios.IsAdmin;

  public roleListarReport: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarReport: boolean = false || Utilitarios.IsAdmin;
  public roleEditarReport: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarReportQuery: boolean = false || Utilitarios.IsAdmin;
  public roleAtivarDesativarReport: boolean = false || Utilitarios.IsAdmin;

  public roleListarReportMenu: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarReportResultado: boolean = false || Utilitarios.IsAdmin;
  public roleSalvarReport: boolean = false || Utilitarios.IsAdmin;
  public roleVisualizarReportSalvo: boolean = false || Utilitarios.IsAdmin;
  public roleInserirRemoverCampos: boolean = false || Utilitarios.IsAdmin;
  public roleReportFilho: boolean = false || Utilitarios.IsAdmin;
  public roleExportarResultado: boolean = false || Utilitarios.IsAdmin;

  public roleListarReportPerfilFiltro: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarReportPerfilFiltro: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarCamposParametrizaveis: boolean = false || Utilitarios.IsAdmin;
  public roleEditarReportPerfilFiltro: boolean = false || Utilitarios.IsAdmin;
  public roleAdicionarCamposParametrizaveisReportPerfilFiltro: boolean = false || Utilitarios.IsAdmin;

  public roleListarLinksCompartilhados: boolean = false || Utilitarios.IsAdmin;

  public VerificarPermissao(pMenu: eMenu): void {

    let _objRetorno = new Utilitarios().RetornarLocalStorageAutenticacao();

    if (!_objRetorno) {
      return;
    }

    if (_objRetorno.dsNome === "god") {
      Utilitarios.IsAdmin = true;
    }

    if (pMenu == eMenu.TodosMenus) {
      this.VerificarPermissaoCliente();
      this.VerificarPermissaoUsuario();
      this.VerificarPermissaoRemetente();
      this.VerificarPermissaoDestinatario();
      this.VerificarPermissaoConfigEmail();
      this.VerificarPermissaoPainel();
      this.VerificarPermissaoDashboardConfiguracao();
      this.VerificarPermissaoGrupoComputador();
      this.VerificarPermissaoMonitoracao();
      this.VerificarPermissaoGrupoVisualizacao();
      this.VerificarPermissaoOcorrencia();
      this.VerificarPermissaoTipoOcorrencia();
      this.VerificarPermissaoEvento();
      this.VerificarPermissaoTipoEvento();
      this.VerificarPermissaoOrigem();
      this.VerificarPermissaoOrigemFilho();
      this.VerificarPermissaoGrupoAgendamento();
      this.VerificarPermissaoAlarme();
      this.VerificarPermissaoAlarmeAlias();
      this.VerificarPermissaoAgendamento();
      this.VerificarPermissaoAuditor();
      this.VerificarPermissaoRestricao();
      this.VerificarPermissaoModulos();
      this.VerificarPermissaoServicos();
      this.VerificarPermissaoReportConexao();
      this.VerificarPermissaoReportGrupo();
      this.VerificarPermissaoReport();
      this.VerificarPermissaoReportMenu();
      this.VerificarPermissaoLinksCompartilhados();
    }
    else if (pMenu == eMenu.Cliente) {
      this.VerificarPermissaoCliente();
    }
    else if (pMenu == eMenu.Usuarios) {
      this.VerificarPermissaoUsuario();
    }
    else if (pMenu == eMenu.Remetente) {
      this.VerificarPermissaoRemetente();
    }
    else if (pMenu == eMenu.Destinatario) {
      this.VerificarPermissaoDestinatario();
    }
    else if (pMenu == eMenu.ConfigEmail) {
      this.VerificarPermissaoConfigEmail();
    }
    else if (pMenu == eMenu.Painel) {
      this.VerificarPermissaoPainel();
    }
    else if (pMenu == eMenu.DashboardConfiguracao) {
      this.VerificarPermissaoDashboardConfiguracao();
    }
    else if (pMenu == eMenu.GrupoComputador) {
      this.VerificarPermissaoGrupoComputador();
    }
    else if (pMenu == eMenu.Monitoracao) {
      this.VerificarPermissaoMonitoracao();
    }
    else if (pMenu == eMenu.GrupoVisualizacao) {
      this.VerificarPermissaoGrupoVisualizacao();
    }
    else if (pMenu == eMenu.Ocorrencia) {
      this.VerificarPermissaoOcorrencia();
    }
    else if (pMenu == eMenu.TipoOcorrencia) {
      this.VerificarPermissaoTipoOcorrencia();
    }
    else if (pMenu == eMenu.Evento) {
      this.VerificarPermissaoEvento();
    }
    else if (pMenu == eMenu.TipoEvento) {
      this.VerificarPermissaoTipoEvento();
    }
    else if (pMenu == eMenu.Origem) {
      this.VerificarPermissaoOrigem();
    }
    else if (pMenu == eMenu.OrigemFilho) {
      this.VerificarPermissaoOrigemFilho();
    }
    else if (pMenu == eMenu.GrupoAgendamento) {
      this.VerificarPermissaoGrupoAgendamento();
    }
    else if (pMenu == eMenu.Alarme) {
      this.VerificarPermissaoAlarme();
    }
    else if (pMenu == eMenu.AlarmeAlias) {
      this.VerificarPermissaoAlarmeAlias();
    }
    else if (pMenu == eMenu.Agendamento) {
      this.VerificarPermissaoAgendamento();
    }
    else if (pMenu == eMenu.Auditor) {
      this.VerificarPermissaoAuditor();
    }
    else if (pMenu == eMenu.Restricao) {
      this.VerificarPermissaoRestricao();
    }
    else if (pMenu == eMenu.Modulos) {
      this.VerificarPermissaoModulos();
    }
    else if (pMenu == eMenu.Servicos) {
      this.VerificarPermissaoServicos();
    }
    else if (pMenu == eMenu.ReportConexao) {
      this.VerificarPermissaoReportConexao();
    }
    else if (pMenu == eMenu.ReportGrupo) {
      this.VerificarPermissaoReportGrupo();
    }
    else if (pMenu == eMenu.Report) {
      this.VerificarPermissaoReport();
    }
    else if (pMenu == eMenu.ReportMenu) {
      this.VerificarPermissaoReportMenu();
    }
    else if (pMenu == eMenu.ReportPerfilFiltro) {
      this.VerificarPermissaoReportPerfilFiltro();
    }
    else if (pMenu == eMenu.LinksCompartilhados) {
      this.VerificarPermissaoLinksCompartilhados();
    }
  }

  private VerificarPermissaoCliente() {
    if (Utilitarios.Roles.length > 0) {
      for (var i = 0; i < Utilitarios.Roles.length; i++) {
        let _obj = Utilitarios.Roles[i];

        if (_obj.rota === "listar-cliente") {
          this.roleListarCliente = true;
        }
        else if (_obj.rota === "adicionar-cliente") {
          this.roleAdicionarCliente = true;
        }
        else if (_obj.rota === "editar-cliente") {
          this.roleEditarCliente = true;
        }
        else if (_obj.rota === "detalhe-cliente") {
          this.roleDetalheCliente = true;
        }
        else if (_obj.rota === "contato-cliente") {
          this.roleContatoCliente = true;
        }
        else if (_obj.rota === "/") {
          this.roleAtivarDesativarCliente = true;
        }
      }
    }
    else {
      if (Utilitarios.IsAdmin) {
        this.roleListarCliente = true;
        this.roleAdicionarCliente = true;
        this.roleEditarCliente = true;
        this.roleDetalheCliente = true;
        this.roleContatoCliente = true;
        this.roleAtivarDesativarCliente = true;
      }
    }
  }

  private VerificarPermissaoUsuario() {
    if (Utilitarios.Roles.length > 0) {
      for (var i = 0; i < Utilitarios.Roles.length; i++) {
        let _obj = Utilitarios.Roles[i];

        if (_obj.rota === "listar-usuario") {
          this.roleListarUsuario = true;
        }
        else if (_obj.rota === "adicionar-usuario") {
          this.roleAdicionarUsuario = true;
        }
        else if (_obj.rota === "editar-usuario") {
          this.roleEditarUsuario = true;
        }
        else if (_obj.rota === "visualizar-usuarios") {
          this.roleVisualizarUsuario = true;
        }
      }
    }
    else {
      if (Utilitarios.IsAdmin) {
        this.roleListarUsuario = true;
        this.roleAdicionarUsuario = true;
        this.roleEditarUsuario = true;
        this.roleVisualizarUsuario = true;
      }
    }
  }

  private VerificarPermissaoRemetente() {
    if (Utilitarios.Roles.length > 0) {
      for (var i = 0; i < Utilitarios.Roles.length; i++) {
        let _obj = Utilitarios.Roles[i];

        if (_obj.rota === "listar-remente") {
          this.roleListarRemetente = true;
        }
        else if (_obj.rota === "adicionar-remetente") {
          this.roleAdicionarRemetente = true;
        }
        else if (_obj.rota === "editar-remetente") {
          this.roleEditarRemetente = true;
        }
        else if (_obj.rota === "ativar-desativar-remetente") {
          this.roleAtivarDesativarRemetente = true;
        }
      }
    }
    else {
      if (Utilitarios.IsAdmin) {
        this.roleListarRemetente = true;
        this.roleAdicionarRemetente = true;
        this.roleEditarRemetente = true;
        this.roleAtivarDesativarRemetente = true;
      }
    }
  }

  private VerificarPermissaoDestinatario() {
    if (Utilitarios.IsAdmin) {
      this.roleListarDestinatarios = true;
      this.roleAdicionarDestinatario = true;
      this.roleEditarDestinatario = true;
      this.roleAtivarDesativarDestinatario = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-destinatario") {
        this.roleListarDestinatarios = true;
      }
      else if (_obj.rota === "adicionar-destinatario") {
        this.roleAdicionarDestinatario = true;
      }
      else if (_obj.rota === "editar-destinatario") {
        this.roleEditarDestinatario = true;
      }
      else if (_obj.rota === "ativar-desativar-destinatario") {
        this.roleAtivarDesativarDestinatario = true;
      }
    }
  }

  private VerificarPermissaoConfigEmail() {
    if (Utilitarios.IsAdmin) {
      this.roleListarConfigEmail = true;
      this.roleAdicionarConfigEmail = true;
      this.roleEditarConfigEmail = true;
      this.roleAtivarDesativarConfigEmail = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-configuracao-email") {
        this.roleListarConfigEmail = true;
      }
      else if (_obj.rota === "adicionar-configuracao-email") {
        this.roleAdicionarConfigEmail = true;
      }
      else if (_obj.rota === "editar-configuracao-email") {
        this.roleEditarConfigEmail = true;
      }
      else if (_obj.rota === "ativar-desativar-configuracao-email") {
        this.roleAtivarDesativarConfigEmail = true;
      }
    }
  }

  private VerificarPermissaoPainel() {
    if (Utilitarios.IsAdmin) {
      this.roleListarPainel = true;
      this.roleAdicionarPainel = true;
      this.roleEditarPainel = true;
      this.roleListarWidget = true;
      this.roleAdicionarWidget = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-painel") {
        this.roleListarPainel = true;
      }
      else if (_obj.rota === "adicionar-painel") {
        this.roleAdicionarPainel = true;
      }
      else if (_obj.rota === "editar-painel") {
        this.roleEditarPainel = true;
      }
      else if (_obj.rota === "listar-widget") {
        this.roleListarWidget = true;
      }
      else if (_obj.rota === "adicionar-widget") {
        this.roleAdicionarWidget = true;
      }
    }
  }

  private VerificarPermissaoDashboardConfiguracao() {
    if (Utilitarios.IsAdmin) {
      this.roleListarDashboardConfiguracao = true;
      this.roleAdicionarDashboardConfiguracao = true;
      this.roleEditarDashboardConfiguracao = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-dashboard-configuracao") {
        this.roleListarDashboardConfiguracao = true;
      }
      else if (_obj.rota === "adicionar-dashboard-configuracao") {
        this.roleAdicionarDashboardConfiguracao = true;
      }
      else if (_obj.rota === "editar-dashboard-configuracao") {
        this.roleEditarDashboardConfiguracao = true;
      }
    }
  }

  private VerificarPermissaoGrupoComputador() {
    if (Utilitarios.IsAdmin) {
      this.roleListarHardwareGrupo = true;
      this.roleAdicionarHardwareGrupo = true;
      this.roleEditarHardwareGrupo = true;
      this.roleAtivarDesativarHardwareGrupo = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-hardware-grupo") {
        this.roleListarHardwareGrupo = true;
      }
      else if (_obj.rota === "adicionar-hardware-grupo") {
        this.roleAdicionarHardwareGrupo = true;
      }
      else if (_obj.rota === "editar-hardware-grupo") {
        this.roleEditarHardwareGrupo = true;
      }
      else if (_obj.rota === "ativar-desativar-hardware-grupo") {
        this.roleAtivarDesativarHardwareGrupo = true;
      }
    }
  }

  private VerificarPermissaoMonitoracao() {
    if (Utilitarios.IsAdmin) {
      this.roleListarMonitoracao = true;
      this.roleVisualizarComputadores = true;
      this.roleVisualizarMonitoracao = true;
      this.roleInserirGrupo = true;
      this.roleEditarAlias = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-monitoracao") {
        this.roleListarMonitoracao = true;
      }
      else if (_obj.rota === "visualizar-computadores") {
        this.roleVisualizarComputadores = true;
      }
      else if (_obj.rota === "visualizar-monitoracao") {
        this.roleVisualizarMonitoracao = true;
      }
      else if (_obj.rota === "inserir-grupo") {
        this.roleInserirGrupo = true;
      }
      else if (_obj.rota === "editar-alias") {
        this.roleEditarAlias = true;
      }
    }
  }

  private VerificarPermissaoGrupoVisualizacao() {
    if (Utilitarios.IsAdmin) {
      this.roleListarVisualizacao = true;
      this.roleAdicionarVisualizacao = true;
      this.roleEditarVisualizacao = true;
      this.roleVisualizarGrupoItem = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-visualizacao") {
        this.roleListarVisualizacao = true;
      }
      else if (_obj.rota === "adicionar-visualizacao") {
        this.roleAdicionarVisualizacao = true;
      }
      else if (_obj.rota === "editar-visualizacao") {
        this.roleEditarVisualizacao = true;
      }
      else if (_obj.rota === "visualizar-grupo-item") {
        this.roleVisualizarGrupoItem = true;
      }
    }
  }

  private VerificarPermissaoOcorrencia() {
    if (Utilitarios.IsAdmin) {
      this.roleListarOcorrencia = true;
      this.roleAdicionarOcorrencia = true;
      this.roleEditarOcorrencia = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-ocorrencia") {
        this.roleListarOcorrencia = true;
      }
      else if (_obj.rota === "adicionar-ocorrencia") {
        this.roleAdicionarOcorrencia = true;
      }
      else if (_obj.rota === "editar-ocorrencia") {
        this.roleEditarOcorrencia = true;
      }
    }
  }

  private VerificarPermissaoTipoOcorrencia() {
    if (Utilitarios.IsAdmin) {
      this.roleListarTipoOcorrencia = true;
      this.roleAdicionarTipoOcorrencia = true;
      this.roleEditarTipoOcorrencia = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-tipo-ocorrencia") {
        this.roleListarTipoOcorrencia = true;
      }
      else if (_obj.rota === "adicionar-tipo-ocorrencia") {
        this.roleAdicionarTipoOcorrencia = true;
      }
      else if (_obj.rota === "editar-tipo-ocorrencia") {
        this.roleEditarTipoOcorrencia = true;
      }
    }
  }

  private VerificarPermissaoEvento() {
    if (Utilitarios.IsAdmin) {
      this.roleListarEvento = true;
      this.roleAdicionarEvento = true;
      this.roleEditarEvento = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-evento") {
        this.roleListarEvento = true;
      }
      else if (_obj.rota === "adicionar-evento") {
        this.roleAdicionarEvento = true;
      }
      else if (_obj.rota === "editar-evento") {
        this.roleEditarEvento = true;
      }
    }
  }

  private VerificarPermissaoTipoEvento() {
    if (Utilitarios.IsAdmin) {
      this.roleListarTipoEvento = true;
      this.roleAdicionarTipoEvento = true;
      this.roleEditarTipoEvento = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-tipo-evento") {
        this.roleListarTipoEvento = true;
      }
      else if (_obj.rota === "adicionar-tipo-evento") {
        this.roleAdicionarTipoEvento = true;
      }
      else if (_obj.rota === "editar-tipo-evento") {
        this.roleEditarTipoEvento = true;
      }
    }
  }

  private VerificarPermissaoOrigem() {
    if (Utilitarios.IsAdmin) {
      this.roleListarOrigem = true;
      this.roleAdicionarOrigem = true;
      this.roleEditarOrigem = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-origem") {
        this.roleListarOrigem = true;
      }
      else if (_obj.rota === "adicionar-origem") {
        this.roleAdicionarOrigem = true;
      }
      else if (_obj.rota === "editar-origem") {
        this.roleEditarOrigem = true;
      }
    }
  }

  private VerificarPermissaoOrigemFilho() {
    if (Utilitarios.IsAdmin) {
      this.roleListarOrigemFilho = true;
      this.roleAdicionarOrigemFilho = true;
      this.roleEditarOrigemFilho = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-origem-filho") {
        this.roleListarOrigemFilho = true;
      }
      else if (_obj.rota === "adicionar-origem-filho") {
        this.roleAdicionarOrigemFilho = true;
      }
      else if (_obj.rota === "editar-origem-filho") {
        this.roleEditarOrigemFilho = true;
      }
    }
  }

  private VerificarPermissaoGrupoAgendamento() {
    if (Utilitarios.IsAdmin) {
      this.roleListarGrupo = true;
      this.roleAdicionarGrupo = true;
      this.roleEditarGrupo = true;
      this.roleAdicionarGrupoDestinatario = true;
      this.roleVisualizarGrupoDestinatario = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-grupo") {
        this.roleListarGrupo = true;
      }
      else if (_obj.rota === "adicionar-grupo") {
        this.roleAdicionarGrupo = true;
      }
      else if (_obj.rota === "editar-grupo") {
        this.roleEditarGrupo = true;
      }
      else if (_obj.rota === "adicionar-grupo-destinatario") {
        this.roleAdicionarGrupoDestinatario = true;
      }
      else if (_obj.rota === "visualizar-grupo-destinatario") {
        this.roleVisualizarGrupoDestinatario = true;
      }
    }
  }

  private VerificarPermissaoAlarme() {
    if (Utilitarios.IsAdmin) {
      this.roleListarAlarme = true;
      this.roleAdicionarAlarme = true;
      this.roleEditarAlarme = true;
      this.roleAtivarDesativarAlarme = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-alarme") {
        this.roleListarAlarme = true;
      }
      else if (_obj.rota === "adicionar-alarme") {
        this.roleAdicionarAlarme = true;
      }
      else if (_obj.rota === "editar-alarme") {
        this.roleEditarAlarme = true;
      }
      else if (_obj.rota === "ativar-desativar-alarme") {
        this.roleAtivarDesativarAlarme = true;
      }
    }
  }

  private VerificarPermissaoAlarmeAlias() {
    if (Utilitarios.IsAdmin) {
      this.roleListarAlarmeAlias = true;
      this.roleAdicionarAlarmeAlias = true;
      this.roleEditarAlarmeAlias = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-alarme-alias") {
        this.roleListarAlarmeAlias = true;
      }
      else if (_obj.rota === "adicionar-alarme-alias") {
        this.roleAdicionarAlarmeAlias = true;
      }
      else if (_obj.rota === "editar-alarme-alias") {
        this.roleEditarAlarmeAlias = true;
      }
    }
  }

  private VerificarPermissaoAgendamento() {
    if (Utilitarios.IsAdmin) {
      this.roleListarAgendamento = true;
      this.roleAdicionarAgendamento = true;
      this.roleEditarAgendamento = true;
      this.roleAtivarDesativarAgendamento = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-agendamento") {
        this.roleListarAgendamento = true;
      }
      else if (_obj.rota === "adicionar-agendamento") {
        this.roleAdicionarAgendamento = true;
      }
      else if (_obj.rota === "editar-agendamento") {
        this.roleEditarAgendamento = true;
      }
      else if (_obj.rota === "ativar-desativar-agendamento") {
        this.roleAtivarDesativarAgendamento = true;
      }
    }
  }

  private VerificarPermissaoAuditor() {
    if (Utilitarios.IsAdmin) {
      this.roleListarAuditor = true;
      this.roleAdicionarAuditor = true;
      this.roleEditarAuditor = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-auditor") {
        this.roleListarAuditor = true;
      }
      else if (_obj.rota === "adicionar-auditor") {
        this.roleAdicionarAuditor = true;
      }
      else if (_obj.rota === "editar-auditor") {
        this.roleEditarAuditor = true;
      }
    }
  }

  private VerificarPermissaoRestricao() {
    if (Utilitarios.IsAdmin) {
      this.roleListarRestricao = true;
      this.roleAdicionarRestricao = true;
      this.roleEditarRestricao = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-restricao") {
        this.roleListarRestricao = true;
      }
      else if (_obj.rota === "adicionar-restricao") {
        this.roleAdicionarRestricao = true;
      }
      else if (_obj.rota === "editar-restricao") {
        this.roleEditarRestricao = true;
      }
    }
  }

  private VerificarPermissaoModulos() {
    if (Utilitarios.IsAdmin) {
      this.roleListarModulo = true;
      this.roleAdicionarModulo = true;
      this.roleEditarModulo = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-modulo") {
        this.roleListarModulo = true;
      }
      else if (_obj.rota === "adicionar-modulo") {
        this.roleAdicionarModulo = true;
      }
      else if (_obj.rota === "editar-modulo") {
        this.roleEditarModulo = true;
      }
    }
  }

  private VerificarPermissaoServicos() {
    if (Utilitarios.IsAdmin) {
      this.roleListarServico = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-servico") {
        this.roleListarServico = true;
      }
    }
  }

  private VerificarPermissaoReportConexao() {
    if (Utilitarios.IsAdmin) {
      this.roleListarReportConexao = true;
      this.roleAdicionarReportConexao = true;
      this.roleEditarReportConexao = true;
      this.roleAtivarDesativarReportConexao = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-report-conexao") {
        this.roleListarReportConexao = true;
      }
      else if (_obj.rota === "adicionar-report-conexao") {
        this.roleAdicionarReportConexao = true;
      }
      else if (_obj.rota === "editar-report-conexao") {
        this.roleEditarReportConexao = true;
      }
      else if (_obj.rota === "ativar-desativar-report-conexao") {
        this.roleAtivarDesativarReportConexao = true;
      }
    }
  }

  private VerificarPermissaoReportGrupo() {
    if (Utilitarios.IsAdmin) {
      this.roleListarReportGrupo = true;
      this.roleAdicionarReportGrupo = true;
      this.roleEditarReportGrupo = true;
      this.roleAtivarDesativarReportGrupo = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-report-grupo") {
        this.roleListarReportGrupo = true;
      }
      else if (_obj.rota === "adicionar-report-grupo") {
        this.roleAdicionarReportGrupo = true;
      }
      else if (_obj.rota === "editar-report-grupo") {
        this.roleEditarReportGrupo = true;
      }
      else if (_obj.rota === "ativar-desativar-report-grupo") {
        this.roleAtivarDesativarReportGrupo = true;
      }
    }
  }

  private VerificarPermissaoReport() {
    if (Utilitarios.IsAdmin) {
      this.roleListarReport = true;
      this.roleAdicionarReport = true;
      this.roleEditarReport = true;
      this.roleAdicionarReportQuery = true;
      this.roleAtivarDesativarReport = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-report") {
        this.roleListarReport = true;
      }
      else if (_obj.rota === "adicionar-report") {
        this.roleAdicionarReport = true;
      }
      else if (_obj.rota === "editar-report") {
        this.roleEditarReport = true;
      }
      else if (_obj.rota === "adicionar-report-query") {
        this.roleAdicionarReportQuery = true;
      }
      else if (_obj.rota === "ativar-desativar-report") {
        this.roleAtivarDesativarReport = true;
      }
    }
  }

  private VerificarPermissaoReportMenu() {
    if (Utilitarios.IsAdmin) {
      this.roleListarReportMenu = true;
      this.roleVisualizarReportResultado = true;
      this.roleSalvarReport = true;
      this.roleVisualizarReportSalvo = true;
      this.roleInserirRemoverCampos = true;
      this.roleReportFilho = true;
      this.roleExportarResultado = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-report-menu") {
        this.roleListarReportMenu = true;
      }
      else if (_obj.rota === "visualizar-report-resultado") {
        this.roleVisualizarReportResultado = true;
      }
      else if (_obj.rota === "salvar-report") {
        this.roleSalvarReport = true;
      }
      else if (_obj.rota === "visualizar-report-salvo") {
        this.roleVisualizarReportSalvo = true;
      }
      else if (_obj.rota === "inserir-remover-campos") {
        this.roleInserirRemoverCampos = true;
      }
      else if (_obj.rota === "report-filtro") {
        this.roleReportFilho = true;
      }
      else if (_obj.rota === "exportar-resultado") {
        this.roleExportarResultado = true;
      }
    }
  }

  private VerificarPermissaoReportPerfilFiltro() {
    if (Utilitarios.IsAdmin) {
      this.roleListarReportPerfilFiltro = true;
      this.roleAdicionarReportPerfilFiltro = true;
      this.roleAdicionarCamposParametrizaveis = true;
      this.roleEditarReportPerfilFiltro = true;
      this.roleAdicionarCamposParametrizaveisReportPerfilFiltro = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-report-perfil-filtro") {
        this.roleListarReportPerfilFiltro = true;
      }
      else if (_obj.rota === "adicionar-report-perfil-filtro") {
        this.roleAdicionarReportPerfilFiltro = true;
      }
      else if (_obj.rota === "adicionar-campos-parametrizaveis") {
        this.roleAdicionarCamposParametrizaveis = true;
      }
      else if (_obj.rota === "editar-report-perfil-filtro") {
        this.roleEditarReportPerfilFiltro = true;
      }
      else if (_obj.rota === "adicionar-report-perfil-filtro-campos-parametrizaveis") {
        this.roleAdicionarCamposParametrizaveisReportPerfilFiltro = true;
      }
    }
  }

  private VerificarPermissaoLinksCompartilhados() {
    if (Utilitarios.IsAdmin) {
      this.roleListarLinksCompartilhados = true;

      return;
    }

    for (var i = 0; i < Utilitarios.Roles.length; i++) {
      let _obj = Utilitarios.Roles[i];

      if (_obj.rota === "listar-links-compartilhados") {
        this.roleListarLinksCompartilhados = true;
      }
    }
  }

  public RetornarErroFront(pErro: any): string {
    var _err = <HttpErrorResponse>pErro;

    let _msg = "";
    if (typeof (_err.error) === "string") {
      _msg = _err.error;
    }
    else {
      _msg = _err.error?.Message;
    }

    return _msg;
  }
}

export enum eMenu {
  TodosMenus = 0,
  Cliente = 1,
  Usuarios = 2,
  Remetente = 3,
  Destinatario = 4,
  ConfigEmail = 5,
  Painel = 6,
  GrupoComputador = 7,
  Monitoracao = 8,
  GrupoVisualizacao = 9,
  Ocorrencia = 10,
  TipoOcorrencia = 11,
  Evento = 12,
  TipoEvento = 13,
  Origem = 14,
  OrigemFilho = 15,
  GrupoAgendamento = 16,
  Alarme = 17,
  AlarmeAlias = 18,
  Agendamento = 19,
  Auditor = 20,
  Restricao = 21,
  Modulos = 22,
  Servicos = 23,
  ReportConexao = 24,
  ReportGrupo = 25,
  Report = 26,
  ReportMenu = 27,
  ReportPerfilFiltro = 28,
  LinksCompartilhados = 29,
  DashboardConfiguracao = 30
}
